export const getDateFormatWithSlash = (value) => {
    if (value != null) {
        const resultat = value.replace(/[^\d]/g, '');
        if (resultat.length < 2) {
            return resultat;
        }
        if (resultat.length === 2) {
            return `${resultat}/`;
        }
        if (resultat.length < 4) {
            return `${resultat.slice(0, 2)}/${resultat.slice(2)}`;
        }
        if (resultat.length === 4) {
            return `${resultat.slice(0, 2)}/${resultat.slice(2)}/`;
        }
        return `${resultat.slice(0, 2)}/${resultat.slice(2, 4)}/${resultat.slice(4, 8)}`;
    }
    return value;
};

export const getTelFormatWithSpace = (value) => {
    if (value != null) {
        const telFormat = value
            .replace(/[^\d0-9]/g, '')
            .replace(/(.{2})/g, '$1 ')
            .trim();
        return telFormat.slice(0, 14);
    }
    return value;
};

export const getTelFormatWithoutSpace = (value) => {
    if (value) {
        return value.replace(/[^\d0-9]/g, '');
    }
    return value;
};
